import apiClient from './apiClient';

export const getCollaborators = async () => {
    try {
        const response = await apiClient.get('/collaborators.php');
        return response.data;
    } catch {
        throw new Error('Impossibile caricare i collaboratori.');
    }
};

export const addCollaborator = async (collaborator) => {
    try {
        const response = await apiClient.post('/users.php?action=create', {
            email: collaborator.email,
            password: collaborator.password,
            nome: collaborator.nome,
            cognome: collaborator.cognome,
            role: collaborator.role,
        });
        return response.data;
    } catch {
        throw new Error('Impossibile aggiungere il collaboratore.');
    }
};

export const updateCollaborator = async (collaborator) => {
    try {
        const response = await apiClient.post('/users.php?action=update', {
            id: collaborator.id,
            email: collaborator.email,
            password: collaborator.password,
            nome: collaborator.nome,
            cognome: collaborator.cognome,
            role: collaborator.role,
        });
        return response.data;
    } catch {
        throw new Error('Impossibile aggiornare il collaboratore.');
    }
};

export const removeCollaborator = async (collaboratorId) => {
    try {
        const response = await apiClient.delete(`/users.php?action=delete&user_id=${collaboratorId}`);
        return response.data;
    } catch {
        throw new Error('Impossibile rimuovere il collaboratore.');
    }
};

export const getUserDetails = async (userId) => {
    try {
        const response = await apiClient.get(`/user_details.php?action=get&user_id=${userId}`);
        return response.data;
    } catch {
        throw new Error('Impossibile caricare i dettagli utente.');
    }
};

export const updateUserDetails = async (formData) => {
    try {
        const response = await apiClient.post('/user_details.php?action=save', formData);
        return response.data;
    } catch {
        throw new Error('Impossibile salvare i dettagli utente.');
    }
};

export const saveAdminDetails = async (payload) => {
    try {
        const response = await apiClient.post('/user_details.php?action=save_admin', payload);
        return response.data;
    } catch {
        throw new Error('Impossibile salvare i dettagli amministratore.');
    }
};

export const deleteUserAttachment = async (attachmentId) => {
    try {
        const response = await apiClient.post('/user_details.php?action=delete_attachment', { attachment_id: attachmentId });
        return response.data;
    } catch {
        throw new Error('Impossibile eliminare il documento.');
    }
};

export const setAdvancedLevel = async (userId, isAdvanced) => {
    try {
        const response = await apiClient.post('/users.php?action=setAdvanced', {
            id: userId,
            is_advanced: isAdvanced,
        });
        return response.data;
    } catch {
        throw new Error('Impossibile aggiornare il livello avanzato.');
    }
};

export const setRestrictedView = async (userId, restrictedView) => {
    try {
        const response = await apiClient.post('/users.php?action=setRestrictedView', {
            id: userId,
            restricted_view: restrictedView,
        });
        return response.data;
    } catch {
        throw new Error('Impossibile aggiornare la vista ristretta.');
    }
};
